import { render, staticRenderFns } from "./AAsignacionProgV3.vue?vue&type=template&id=109fe1fa&scoped=true"
import script from "./AAsignacionProgV3.vue?vue&type=script&lang=js"
export * from "./AAsignacionProgV3.vue?vue&type=script&lang=js"
import style0 from "./AAsignacionProgV3.vue?vue&type=style&index=0&id=109fe1fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109fe1fa",
  null
  
)

export default component.exports